<div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
        <form [formGroup]="form" (ngSubmit)="refineIcpScore()" method="POST">

          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="px-4 py-4 lg:px-6 lg:py-4">
            <h3 class="text-lg font-semibold leading-6 text-gray-900" id="modal-title">Improve your lead score</h3>
            <p class="text-sm text-gray-500">by answering a few questions</p>

            <div class="mt-8 flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <table class="min-w-full divide-y divide-gray-300">
                    <thead>
                    <tr>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"></th>
                      <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-20">Yes</th>
                      <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-20">No</th>
                      <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-20">N/A</th>
                    </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200">
                    <tr *ngFor="let question of questions">
                      <td class="py-4 pl-4 pr-3 text-sm font-medium text-gray-700 sm:pl-0">
                        {{ question.text }}
                      </td>
                      <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <input
                          type="radio"
                          name="{{ question.id }}"
                          (change)="selectAnswer(question.id, 'yes')"
                          [checked]="selectedValues[question.id] === 'yes'"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        >
                      </td>
                      <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <input
                          type="radio"
                          name="{{ question.id }}"
                          (change)="selectAnswer(question.id, 'no')"
                          [checked]="selectedValues[question.id] === 'no'"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        >
                      </td>
                      <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <input
                          type="radio"
                          name="{{ question.id }}"
                          (change)="selectAnswer(question.id, 'na')"
                          [checked]="selectedValues[question.id] === 'na'"
                          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        >
                      </td>
                    </tr>

                    <!-- Show the textarea for "Can you confirm that the customer seeks and accepts advise?" -->
                    <tr *ngIf="selectedValues['acceptAdvise'] === 'yes'">
                      <td colspan="5" class="py-4 pl-4 pr-3 text-sm">
                        <fieldset [disabled]="loading$ | async">
                          <label for="acceptAdviseDetails" class="block text-sm font-medium leading-6 text-gray-900">Please provide details (required)</label>
                          <div class="mt-2">
                            <textarea rows="4" formControlName="acceptAdviseDetails" id="acceptAdviseDetails" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                          </div>
                          <div class="pt-1" *ngIf="form.get('acceptAdviseDetails')?.invalid && form.get('acceptAdviseDetails')?.touched">
                            <div class="ng-invalid text-xs text-red-500">This field is required.</div>
                          </div>
                        </fieldset>
                      </td>
                    </tr>

                    <!-- Show the textarea for "Can you confirm that there is a sense of urgency?" -->
                    <tr *ngIf="selectedValues['senseUrgency'] === 'yes'">
                      <td colspan="5" class="py-4 pl-4 pr-3 text-sm">
                        <fieldset [disabled]="loading$ | async">
                          <label for="urgencyDetails" class="block text-sm font-medium leading-6 text-gray-900">Please provide details (required)</label>
                          <div class="mt-2">
                            <textarea rows="4" formControlName="urgencyDetails" id="urgencyDetails" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                          </div>
                          <div class="pt-1" *ngIf="form.get('urgencyDetails')?.invalid && form.get('urgencyDetails')?.touched">
                            <div class="ng-invalid text-xs text-red-500">This field is required.</div>
                          </div>
                        </fieldset>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>

          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <!-- Disable the submit button if the form is invalid or still loading -->
            <button type="submit" [disabled]="isSubmitDisabled$ | async" class="inline-flex w-full justify-center rounded-md bg-[#802cfa] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 sm:ml-3 sm:w-auto">
              Refine the ICP Score
            </button>
            <button type="button" [disabled]="loading$ | async" (click)="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
              Cancel
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
